import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { KeycloakService } from "keycloak-angular";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { LanguageService } from "../services/language.service";

@Injectable({
  providedIn: "root"
})
export class AuthInterceptor implements HttpInterceptor {
  private language: string;

  constructor(
    private router: Router,
    private keycloackService: KeycloakService,
    private languageService: LanguageService
  ) {
    this.languageService.getLanguage$().subscribe((res) => {
      this.language = res;
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.language) {
      req = req.clone({
        setHeaders: {
          "Accept-Language": this.language
        }
      });
    }

    return next.handle(req).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.keycloackService.logout(environment.logoutUrl);
            } else if (err.status === 403) {
              this.router.navigateByUrl("unauthorized");
            } else {
              return;
            }
          }
        }
      )
    );
  }
}
